import type { TransformedShelf } from '../types'
import type { StockLevelMapper } from '@utils/stockLevelMapper'

/**
 * Maps stock levels based on user role.
 *
 * Applies business logic to transform stock level values according to the
 * user's permissions and role (e.g., DEVELOPER sees UNKNOWN, others see HAS_STOCK).
 *
 * Type flow: TransformedShelf → TransformedShelf (same type, modified values)
 */
export function applyStockLevelTransformation(
  shelf: TransformedShelf,
  stockLevelMapper: StockLevelMapper
): TransformedShelf {
  return {
    ...shelf,
    layers: shelf.layers.map(layer => ({
      ...layer,
      facings: layer.facings.map(facing => ({
        ...facing,
        stockLevel: facing.stockLevel
          ? stockLevelMapper.map(facing.stockLevel)
          : facing.stockLevel,
      })),
    })),
  }
}

